import React, { useState } from "react";
import Image from "gatsby-image";
import { Link } from "gatsby";
import {
	Heading,
	Subheading,
	HeadingLarge,
	BodyText,
} from "~/components/.base/headings";
import { RedButton } from "~/components/.base/buttons";
import Slideshow from "~/components/.base/slideshow";
import { SearchFormLarge } from "~/components/.base/inputs";
import {
	Grid,
	Row,
	Col,
	CenteredContainer,
	FlexBox,
	BackgroundDivBgImage,
	BorderedImage,
} from "~/components/.base/containers";
import PhoneIcon from "~/images/icons/phone.svg";
import EmailIcon from "~/images/icons/email.svg";
import PinIcon from "~/images/icons/pin.svg";
import food_truck_sm from "~/images/locations/food_truck_sm.jpg";
import restaurant from "~/images/locations/restaurant.jpg";
import frying_pan from "~/images/locations/frying_pan.png";
import grilled_cheese from "~/images/locations/grilled-cheese-b-m.png";
import blurry_thing from "~/images/locations/blurry_thing.png";
import crab_leg from "~/images/locations/crab_leg.png";
import SearchIcon from "~/images/icons/search.svg";
import border_white from "~/images/background/border_white.png";
import blurred_map_smudge from "~/images/background/weird_map_smudges/blurred_smudge_2@2x.png";
import "./DetailFooter.scss";

const DetailFooter = ({
	isATruck,
	title,
	truckDetails,
	phoneNumber,
	emailAddress,
	physicalAddress,
	lowerFooterTitle,
	upperFooterBlocks,
	lowerFooterBlocks,
}) => {
	const [zipCode, setZipCode] = useState("");
	const [zipWarning, setZipWarning] = useState("");
	const handleSearch = (e) => {
		e.preventDefault();
		if (zipCode.length === 5) {
			window.location.href = `/locations/search?q=${zipCode}`;
		} else {
			setZipWarning("Please enter a valid ZIP code");
		}
	};
	return (
		<div className="rel-cont">
			<BorderedImage
				top="190px"
				bottom="auto"
				topMobile="535px"
				topBottomBorder="1895px"
				topBottomBorderMobile="2215px"
				tablet={true}
			>
				<img src={border_white} alt="border" className="top-border" />
				<img
					src={border_white}
					alt="border"
					className="bottom-border"
				/>
				<BackgroundDivBgImage
					width="100%"
					height="1680px"
					top="250px"
					topMobile="555px"
					color="#edf2f2"
					style={{ zIndex: "-2" }}
					tablet={true}
				/>
			</BorderedImage>
			<img
				src={blurred_map_smudge}
				alt="map background"
				className="map-background"
			/>
			<img
				src={grilled_cheese}
				alt="grilled cheese"
				className="grilled-cheese"
			/>
			<Grid className="detail-footer">
				<Row className="truck-contact-info">
					<Col size={3} pd="1rem">
						<Subheading>
							{isATruck ? "Truck " : "Restaurant "}Details
						</Subheading>
						<BodyText>
							For customer service for the {title} restaurant,
							please use the following:
						</BodyText>
					</Col>
					<Col size={3} pd="1rem">
						{!isATruck ? (
							<FlexBox className="address-item" align="center">
								<PinIcon style={{ width: "24px" }} />
								<a
									href={`https://maps.google.com/?q=${emailAddress}`}
									target="_blank"
								>
									<span>{physicalAddress}</span>
								</a>
							</FlexBox>
						) : null}
						{phoneNumber ? (
							<FlexBox className="address-item" align="center">
								<PhoneIcon />
								<a href={`tel:${phoneNumber}`}>
									<span>{phoneNumber}</span>
								</a>
							</FlexBox>
						) : null}
						{emailAddress ? (
							<FlexBox className="address-item" align="center">
								<EmailIcon className="mail-icon" />
								<a href={`mailto:${emailAddress}`}>
									<span>{emailAddress}</span>
								</a>
							</FlexBox>
						) : null}
					</Col>
					<Col size={3} pd="1rem" className="desktop-only">
						<FlexBox align="center">
							{isATruck ? (
								<img src={food_truck_sm} alt="restaurant" />
							) : (
								<img src={restaurant} alt="food truck" />
							)}
							<Heading md="0 0 0 1rem">
								Other {isATruck ? "trucks" : "restaurants"} may
								be <span className="red">near you!</span>
							</Heading>
						</FlexBox>
					</Col>
					<Col size={4} pd="1rem">
						<form onSubmit={handleSearch}>
							<SearchFormLarge>
								<Subheading>ZIP code</Subheading>
								<input
									placeholder="Enter zip code"
									type="number"
									min="0"
									max="99999"
									value={zipCode}
									onChange={(e) => setZipCode(e.target.value)}
								/>
								<button className="no-stroke" type="submit">
									<SearchIcon />
								</button>
								<div className="error">{zipWarning}</div>
							</SearchFormLarge>
						</form>
					</Col>
				</Row>
				<div className="upper-blocks">
					{upperFooterBlocks ? (
						upperFooterBlocks.map((block, i) => (
							<Row
								className="upper-module"
								key={i}
								reverse={i % 2 !== 0}
							>
								<Col size={1} pd="2.5rem">
									<CenteredContainer className="half-section-details">
										<HeadingLarge>
											<span
												dangerouslySetInnerHTML={{
													__html: block.heading,
												}}
											></span>
										</HeadingLarge>
										<BodyText>
											{block.description
												? block.description.description
												: ""}
										</BodyText>
									</CenteredContainer>
								</Col>
								<Col size={1} pd="2.5rem">
									{block.image ? (
										block.image.length > 1 ? (
											<Slideshow>
												{block.image.map((i) => (
													<div className="image-cont">
														<img
															src={i.fixed.src}
															alt={i.fixed.title}
														/>
													</div>
												))}
											</Slideshow>
										) : (
											<div className="image-cont">
												<img
													src={
														block.image[0].fixed.src
													}
													alt="Locally Owned"
												/>
											</div>
										)
									) : null}
								</Col>
							</Row>
						))
					) : (
						<div />
					)}
					<img
						src={frying_pan}
						alt="frying pan"
						className="frying-pan"
					/>
					<img
						src={blurry_thing}
						alt="blurry thing"
						className="blurry-thing"
					/>
					<img src={crab_leg} alt="crab leg" className="crab-leg" />
				</div>
				{lowerFooterTitle ? (
					<Row className="ready-to-eat heading">
						<HeadingLarge
							md="0 0 2.5rem"
							dangerouslySetInnerHTML={{
								__html: lowerFooterTitle,
							}}
						></HeadingLarge>
					</Row>
				) : null}
				<Row className="ready-to-eat content">
					{lowerFooterBlocks ? (
						lowerFooterBlocks.map((block, i) => (
							<Col size={1}>
								<Link to={block.link}>
									<CenteredContainer>
										<div className="image-cont">
											<Image
												fluid={
													block.image
														? block.image.fluid
														: null
												}
												alt={block.buttonText}
											/>
										</div>
										<RedButton>
											{block.buttonText}
										</RedButton>
									</CenteredContainer>
								</Link>
							</Col>
						))
					) : (
						<div />
					)}
				</Row>
			</Grid>
		</div>
	);
};

export default DetailFooter;
